import type {State} from '../../../../reducers/types'
import {getAgentPool} from '../../../../selectors'
import type {AgentPoolId} from '../../../../types'

export const getAgentPoolName = (
  state: State,
  agentPoolId: AgentPoolId | null | undefined,
): string | null | undefined =>
  agentPoolId != null ? getAgentPool(state, agentPoolId)?.name : null
